import { LoginResponse } from './login-response';
// import { TrustedString } from '@angular/core/src/sanitization/bypass';

export class CurrentUser {
  userID: string;
  name: string;
  token: string;
  username: string;
  lastLogin: string;
  role: any;
  userData: any;
  refreshToken: string;
  logintTime: number;
  expiresIn: number;
  subOperatorLogo: string;
  favIcon: string;
  constructor(loginResponse = new LoginResponse()) {
    this.userID = loginResponse.id;
    this.token = loginResponse.token;
    this.role = loginResponse.role;
  }
  setAllFields(loginResponse = new LoginResponse()) {
    this.userID = loginResponse.id;
    this.token = loginResponse.token;
    this.role = loginResponse.role;
  }
}
